// src/pages/admin/AdminLayout.jsx
import { NavLink, Outlet } from 'react-router-dom'

export default function AdminLayout() {
  const tab = 'px-3 py-2 rounded-md border hover:bg-gray-50 text-sm'
  const active = ({ isActive }) => (isActive ? `${tab} bg-gray-100` : tab)

  return (
    <div className="max-w-6xl mx-auto px-4 py-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold">🔐 Admin</h1>
      </div>
      <nav className="flex gap-2 mb-4">
        <NavLink to="/admin/reviews" className={active}>심사 큐</NavLink>
        <NavLink to="/admin/users" className={active}>회원 관리</NavLink>
        <NavLink to="/admin/jobs" className={active}>공고 관리</NavLink>
        <NavLink to="/admin/applications" className={active}>지원 현황</NavLink>
        <NavLink to="/admin/settings" className={active}>설정</NavLink>
      </nav>
      <Outlet />
    </div>
  )
}
